import type {
    CalculateCommerceCheckoutRequest,
    CalculateCommerceCheckoutResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const calculateCommerceCheckoutOperation = defineCommerceOperation<
    CalculateCommerceCheckoutRequest,
    CalculateCommerceCheckoutResponse
>("commerce.checkout.calculate");
